import img from '../../helpers/img';

export default {
  title: 'Westfield',
  tile: {
    grid: 'col-12 lap-6',
    bgImage: img('westfield/westfield-hero.jpg')
  },
  hero: {
    bgPosition: 'top',
    bgImage: img('westfield/westfield-hero.jpg')
  },
  info: {
    client: 'Westfield Labs',
    timeline: 'Nov 2014 - Apr 2016',
    description: [
      'Westfield Labs creates both physical and digital experiences for shoppers in Westfield malls.',
      'I led front end development on a number of projects including:',
      '::websites for all 37 US Westfield centres (westfield.com)',
      '::wayfinding kiosk software - for helping shoppers find stores',
      '::an interactive experience for the PRISM installation in Westfield Garden State Plaza'
    ],
    tools: `
      HTML,
      CSS,
      JS (ES6),
      SASS,
      Node,
      Ruby,
      Gulp,
      Bower,
      NPM,
      Famous
    `,
    buttons: [{
      text: 'VIEW WEBSITE',
      url: 'http://www.westfield.com/sanfrancisco'
    }]
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('westfield/westfield-hero.jpg'),
      caption: 'Westfield 2015 Hero'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('westfield/westfield-us.jpg'),
      caption: 'Westfield US Centres'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('westfield/westfield-san-francisco.jpg'),
      caption: 'Westfield San Francisco Centre'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('westfield/westfield-annapolis.jpg'),
      caption: 'Westfield Annapolis'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/westfield.js